module.exports = __webpack_public_path__ + "static/media/natal-rn.3daee10d.jpg";